export default __webpack_public_path__ + "static/media/Rival-Logo-White.fda40cac.svg";